import { useState, useEffect } from "react";

const creators = [
  {
    name: "けんたろう",
    color: "#FF0F0F",
    colorLight: "#FFF0F0",
    bgClass: "bg-[#FF0F0F]",
    borderClass: "border-[#FF0F0F]",
    shadowClass: "rgba(255,15,15,0.3)",
    shadowSolid: "#FF0F0F",
    role: "トラックボーイズ 発起人",
    rating: "R15指定",
    ratingIcon: "🔞",
    desc: "トラックボーイズの発起人。くだらない動画を得意とする。深夜バラエティ色強め。親に見せれない。R15指定。",
    tags: ["#深夜バラエティ", "#くだらない", "#R15"],
    decorations: ["💀", "🎲", "🚨"],
    stampText: "R15\n指定",
    stampBg: "bg-[#FF0F0F]",
    btnText: "けんたろうおすすめセレクション↓",
    btnUrl: "https://youtube.com/playlist?list=PLEvleHvb7Eg80_Z086jwL2KnzZwbnOz8z&si=nV-z8fd4__uY_SWg",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/6eee3ff76285cd9d3b326671e6aa8496.png",
  },
  {
    name: "茂木さん",
    color: "#00B050",
    colorLight: "#F0FFF0",
    bgClass: "bg-[#00B050]",
    borderClass: "border-[#00B050]",
    shadowSolid: "#00B050",
    role: "トラックボーイズ 唯一の良心",
    rating: "全年齢対応",
    ratingIcon: "👨‍👩‍👧‍👦",
    desc: "トラックボーイズ唯一の良心。家族で安心して見られる動画を得意とする。日曜6時のバラエティくらいほっこりする。親にも見せれる。全年齢対応。",
    tags: ["#ほっこり", "#良心", "#全年齢対応"],
    decorations: ["😇", "🌿", "⭐"],
    stampText: "全年齢\n対応",
    stampBg: "bg-[#00B050]",
    btnText: "茂木さんおすすめセレクション↓",
    btnUrl: "https://youtube.com/playlist?list=PLEvleHvb7Eg9R2DsFL9d650caDlwzqHnK&si=SW4uEvEzEoTPkBR8",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/08fff03c0ed596ff03568947a390022a.png",
  },
  {
    name: "ゆきちゃん",
    color: "#0066FF",
    colorLight: "#F0F5FF",
    bgClass: "bg-[#0066FF]",
    borderClass: "border-[#0066FF]",
    shadowSolid: "#0066FF",
    role: "トラックボーイズ NG無しの大食漢",
    rating: "NGなし",
    ratingIcon: "🍣",
    desc: "NG無しの大食漢。回転寿司60皿食う。バラエティノリの動画を得意とする。下ネタに寛容。（なんなら好き。）一部、親には見せれない。",
    tags: ["#大食い", "#寿司60皿", "#NGなし"],
    decorations: ["🍣", "🍜", "😂"],
    stampText: "NG\nなし",
    stampBg: "bg-[#0066FF]",
    btnText: "ゆきちゃんおすすめセレクション↓",
    btnUrl: "https://youtube.com/playlist?list=PLEvleHvb7Eg9wdZsTvLI9aaf2Ql-Pm4tJ&si=xN67gmErcnNxjh93",
    img: "https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/a05798bef5392e90624a742f543c9bf8.jpeg",
  },
];

function useScrollAnim() {
  useEffect(() => {
    const els = document.querySelectorAll(".anim-fade-up, .anim-fade-left, .anim-fade-right, .anim-scale-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function Creators() {
  const [hovered, setHovered] = useState<number | null>(null);
  useScrollAnim();

  return (
    <section id="creators" className="py-20 bg-[#F9F9F9] relative overflow-hidden">
      {/* Floating accent image */}
      <img
        src="https://storage.readdy-site.link/project_files/b4049c21-524e-4360-bd0f-e8c5b9d42418/b19d9893-305b-421d-9439-c915cfbb2cce_unnamed.png?v=9072e3d998ffa4ecffe4095fbe82d14d"
        alt=""
        className="absolute bottom-6 left-4 w-24 md:w-36 opacity-75 pointer-events-none animate-float"
        style={{ "--rot": "-8deg" } as React.CSSProperties}
      />
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section header */}
        <div className="text-center mb-16 anim-fade-up">
          <div className="inline-block bg-black text-white font-black text-sm px-6 py-2 rounded-full mb-4 tracking-widest">
            CAST
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-black">
            クリエイター陣<br />
            <span className="text-[#FF0F0F]">メイン</span>
            <span className="text-[#00B050]">キャスト</span>
            <span className="text-[#0066FF]">紹介</span>
          </h2>
          <p className="text-gray-500 font-bold mt-3">こんなやつらが作ってます！</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {creators.map((creator, i) => (
            <div
              key={i}
              className={`relative bg-white border-4 ${creator.borderClass} rounded-3xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-3 anim-fade-up anim-delay-${(i + 1) * 200}`}
              style={{ boxShadow: hovered === i ? `8px 8px 0px ${creator.shadowSolid}` : `4px 4px 0px ${creator.shadowSolid}` }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              {/* Header color bar */}
              <div className={`${creator.bgClass} h-3`} />

              {/* Image area */}
              <div className={`relative bg-[${creator.colorLight}] flex justify-center pt-6 pb-0`}
                style={{ background: creator.colorLight }}>
                {/* Decorations */}
                <div className="absolute top-2 left-3 flex flex-col gap-1">
                  {creator.decorations.map((d, di) => (
                    <span key={di} className="text-2xl animate-float" style={{ animationDelay: `${di * 0.4}s` }}>{d}</span>
                  ))}
                </div>
                {/* Stamp */}
                <div className="absolute top-3 right-3 z-10">
                  <div className={`${creator.stampBg} text-white font-black text-xs text-center px-2 py-1 rounded border-2 border-black animate-wiggle`}
                    style={{ whiteSpace: "pre-line", lineHeight: "1.3" }}>
                    {creator.stampText}
                  </div>
                </div>
                <img
                  src={creator.img}
                  alt={creator.name}
                  className="w-52 h-64 object-cover object-top rounded-t-2xl"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-2xl`}>{creator.ratingIcon}</span>
                  <div>
                    <p className="text-xs font-black text-gray-400 tracking-widest">{creator.role}</p>
                    <h3 className="text-2xl font-black text-black">{creator.name}</h3>
                  </div>
                  <span className={`ml-auto ${creator.bgClass} text-white font-black text-xs px-2 py-1 rounded-full border-2 border-black`}>
                    {creator.rating}
                  </span>
                </div>

                <p className="text-sm font-bold text-gray-600 leading-relaxed mt-3 mb-4">
                  {creator.desc}
                </p>

                <div className="flex flex-wrap gap-1 mb-4">
                  {creator.tags.map((tag) => (
                    <span key={tag} className="text-xs font-black text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>

                <a
                  href={creator.btnUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`block w-full ${creator.bgClass} text-white font-black text-sm py-3 rounded-xl border-4 border-black whitespace-nowrap cursor-pointer hover:opacity-90 hover:scale-[1.02] transition-all text-center`}
                  style={{ boxShadow: `3px 3px 0px #000` }}
                >
                  {creator.btnText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
